import Vue from 'vue'
import App from './App.vue'
import L from 'leaflet'
import VueRouter from 'vue-router'
import Map from './components/Map.vue'
import VueResource from 'vue-resource'
import vSelect from 'vue-select'
import VueNotifications from 'vue-notifications'
import 'jquery'
import toastr from 'toastr'// https://github.com/CodeSeven/toastr
import 'toastr/build/toastr.min.css'
import VModal from 'vue-js-modal'
import moment from "moment";
import 'jquery/dist/jquery'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.js'
import NProgress from 'nprogress/nprogress.js'
import 'nprogress/nprogress.css'

Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(VModal);
Vue.component('v-select', vSelect);
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});


export const globalStore = new Vue({
    data: {
        apiBaseUrl: process.env.VUE_APP_API_BASE_URL ? process.env.VUE_APP_API_BASE_URL : 'https://contrataciones.gov.py:443/datos/api/v2/'
    }
});


Vue.config.productionTip = false;
const REQUEST_TOKEN = process.env.VUE_APP_REQUEST_TOKEN ? process.env.VUE_APP_REQUEST_TOKEN : 'OTkxMzYzZmYtNWJiZi00NzdjLTkxMDUtNTdlMzc1OGY1Yjk5OjZkMjUyOWQ2LWI1NDgtNDMwNC05YWE3LTQ4ZDljNjdkYjY3MA==';
const REQUEST_TOKEN_URL = globalStore.apiBaseUrl + "oauth/token";
function toast ({title, message, type, timeout}) {
    if (type === VueNotifications.types.warn) type = 'warning';
    return toastr[type](message, title, {timeOut: timeout})
}

const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
};
Vue.use(VueNotifications, options);
Vue.http.interceptors.push(
    function (request){
        NProgress.start();
        if(request.url === REQUEST_TOKEN_URL) {

            request.headers.set('Content-Type', '');
            request.headers.set('Authorization', 'Basic ' + REQUEST_TOKEN);
        } else {
            request.headers.set('Authorization', 'Bearer ' + window.localStorage.getItem("authToken"));
        }
    });

Vue.http.interceptors.push(function (request, next) {
    next((response) => {
        NProgress.done();
        if (response.status === 429 || response.status === 401) {
            this.$http.post(this.REQUEST_TOKEN_URL).then(
                response => {
                    window.localStorage.setItem("authToken", response.data.access_token);
                }
            );
        }
    })
});
Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY hh:mm');
    }
});

const routes = [
  { path: '/map', component: Map },
    { path: '/map/:llamado_slug', component: Map }
];

const router = new VueRouter({
  routes
});

new Vue({
  render: h => h(App),
  router
}).$mount('#app');
